import axios from 'axios'

export default {
    // getVacancyByAnnounsment: async function (params) {
    //     return axios.post( `http://localhost:8088/api/v.1/ownVacancyList-vacancy`, params )
    // },
    // getDirectionRegion: async function () {
    //     return axios.get( `http://localhost:8088/api/v.1/list-uzb-regions-vacancy` )
    // },
    getVacancyByAnnounsment: async function (params) {
        return axios.post( `https://apivacancy.adliya.uz/api/v.1/ownVacancyList-vacancy`, params )
    },
    getcontragentListSelectList: async function (id) {
        return axios.get( `https://apivacancy.adliya.uz/api/v.1/vacancy-contragent/${id}` )
    },
    getDirectionRegion: async function () {
        return axios.get( `https://apivacancy.adliya.uz/api/v.1/list-uzb-regions-vacancy` )
    },
}
